<div class="inner">
	<button mat-icon-button (click)="openFeedbackDialog()">
		<mat-icon>feedback</mat-icon>
	</button>
</div>
